<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'
  export default {
    name: 'App',
    created() {
      if (this.getCookie('userInfo')) {
        this.aUserInfo(JSON.parse(this.getCookie('userInfo')))
      }
    },
    methods: {
      ...mapActions([
        "aUserInfo"
      ])
    }
  }
</script>

<style>
  #app {
  }
</style>



// WEBPACK FOOTER //
// src/App.vue